function resize(element) {
  // eslint-disable-next-line no-param-reassign
  element.style.height = 'auto';
  // eslint-disable-next-line no-param-reassign
  element.style.height = `${element.scrollHeight}px`;
}

// Automatically resizes a textarea to match its content.
export default {
  bind(element) {
    // eslint-disable-next-line no-param-reassign
    element.style.resize = 'none';
    // eslint-disable-next-line no-param-reassign
    element.rows = 1;
  },
  inserted(element) {
    resize(element);
  },
  update(element) {
    resize(element);
  },
};
